import { Table } from '@tanstack/react-table';

import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { DraggableTableHeader } from './DraggableTableHeader';
import { TABLE_CHECKBOX_COLUMN_ID } from './tableConstants';

interface TableHeaderProps<TData extends object> {
  table: Table<TData>; // TanStack Table 인스턴스
  columnOrder: string[]; // 컬럼 ID 배열
  isSticky?: boolean;
  enableResize?: boolean; // 컬럼 너비 조절 핸들 표시 여부
  onMeasureMin?: (columnId: string, minWidth: number) => void; // 헤더 실측 최소너비 보고
}

export const TableHeader = <TData extends object>({
  table,
  columnOrder,
  isSticky = true,
  enableResize = false,
  onMeasureMin,
}: TableHeaderProps<TData>) => {
  return (
    <thead
      // 테이블 박스(LayoutTables)가 이미 상단 보더를 그리므로 헤더는 하단 보더만 둔다(상단 이중선 방지).
      className={isSticky ? 'sticky top-0 z-[20] border-b border-gr-300' : 'border-b border-gr-300'}
    >
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className="overflow-hidden">
          {/* 체크박스 컬럼은 항상 맨 앞에 고정 */}
          {headerGroup.headers
            .filter((header) => header.column.id === TABLE_CHECKBOX_COLUMN_ID)
            .map((header) => (
              <DraggableTableHeader key={header.id} header={header} disableDrag />
            ))}
          {/* 나머지 컬럼만 드래그 가능 */}
          <SortableContext items={columnOrder} strategy={horizontalListSortingStrategy}>
            {headerGroup.headers
              .filter((header) => header.column.id !== TABLE_CHECKBOX_COLUMN_ID)
              .map((header) => (
                <DraggableTableHeader
                  key={header.id}
                  header={header}
                  enableResize={enableResize}
                  onMeasureMin={onMeasureMin}
                />
              ))}
          </SortableContext>
        </tr>
      ))}
    </thead>
  );
};
